import { createStore } from 'vuex';
import auth from '@/modules/auth/store';
import cliente from '@/modules/client/store';
import poliza from '@/modules/poliza/store';
import agro from '@/modules/agro/store';
import siniestros from '@/modules/siniestros/store';
import art from '@/modules/art/store';
import main from '@/modules/main/index';
import bsa from '@/modules/bsa/store';
import caucion from '@/modules/caucion/store';
import reportes from '@/modules/reportes/store';
import automotor from '@/modules/automotor/store';
import creditos from '@/modules/creditos/store';
import hipoteca from '@/modules/hipoteca/store';
import responsabilidadCivil from '@/modules/responsabilidad-civil/store';

const store = createStore({
   modules: {
      auth,
      cliente,
      poliza,
      agro,
      siniestros,
      art,
      main,
      bsa,
      caucion,
      reportes,
      automotor,
      creditos,
      hipoteca,
      responsabilidadCivil,
   },
});
export default store;
